  <section class="main-section data-management-section">
    <header class="d-md-flex d-block justify-content-between align-items-center main-heading pe-0">
      <div class="row w-100">
        <div class="col-md-3">
      <div class="d-flex align-items-center">
        <a class="btn btn-link me-3 p-0 d-block d-xl-none" data-bs-toggle="offcanvas" href="#offcanvasExample" role="button" aria-controls="offcanvasExample">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 7H21" stroke="#292D32" stroke-width="1.5" stroke-linecap="round"/>
          <path d="M3 12H21" stroke="#292D32" stroke-width="1.5" stroke-linecap="round"/>
          <path d="M3 17H21" stroke="#292D32" stroke-width="1.5" stroke-linecap="round"/>
          </svg></a>
        <h3 class="heading-span"><span>{{"Data Management"}}</span></h3>
      </div>
      </div>
      <div *ngIf="!pageTitle && !hideGlobalCreate" class="col-md-7">
      <div class="d-flex justify-content-end me-3">
        <div class="input-group me-2 user-center-search mt-2 mt-md-0">
          <span class="input-group-text bg-transparent" id="basic-addon1"
            (click)="onSearch()">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M15.7138 6.8382C18.1647 9.28913 18.1647 13.2629 15.7138 15.7138C13.2629 18.1647 9.28913 18.1647 6.8382 15.7138C4.38727 13.2629 4.38727 9.28913 6.8382 6.8382C9.28913 4.38727 13.2629 4.38727 15.7138 6.8382"
                stroke="#999999" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M19 19L15.71 15.71" stroke="#999999" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </span>
          <input type="text" class="form-control usercenter-searchcontrol ps-0 bg-white" placeholder="Search"
            aria-label="Username" aria-describedby="basic-addon1" [(ngModel)]="searchTerm"
            (keyup.enter)="onSearch()" />
        </div>
        <mat-icon matTooltip="{{searchBy}}" matTooltipPosition="above" class="fs-22 m-2">info</mat-icon>
      </div>
    </div>
    <div class="col-md-2">
      <div>
        <div class="d-flex justify-content-end" *ngIf="activeTab != tabs.Metrics && !pageTitle && !hideGlobalCreate">
          <button type="button" class="btn theme-btn px-sm-4 px-2" (click)="showCreateForm(); setPageTitleTriggered({tab: activeTab, mode: mode.Create})">
            <span class="d-block d-sm-none"><svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M5 12H19" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M12 5V19" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg></span>
            <span class="d-none d-sm-block">Create {{activeTab}}</span>
          </button>
        </div>
      </div>
    </div>
    </div>
    </header>

    <div class="tabs">
      <ul class="nav nav-tabs" id="myTab" role="tablist">
        <li class="nav-item" role="presentation">
          <button (click)="setTabName(tabs.Module);closeCreateForm()" class="nav-link active" id="module-tab" data-bs-toggle="tab" data-bs-target="#module-tab-pane" type="button" role="tab" aria-controls="module-tab-pane" aria-selected="true"><span>Module</span></button>
        </li>
        <li class="nav-item" role="presentation">
          <button (click)="setTabName(tabs.SubCategory);closeCreateForm()" class="nav-link" id="category-tab" data-bs-toggle="tab" data-bs-target="#category-tab-pane" type="button" role="tab" aria-controls="category-tab-pane" aria-selected="false"><span>Analytics Toolkit</span></button>
        </li>
        <li class="nav-item" role="presentation">
          <button (click)="setTabName(tabs.Metrics);closeCreateForm()" class="nav-link" id="metrics-tab" data-bs-toggle="tab" data-bs-target="#metrics-tab-pane" type="button" role="tab" aria-controls="metrics-tab-pane" aria-selected="false"><span>Metric</span></button>
        </li>
      </ul>
    </div>
    <div class="tab-content" id="myTabContent">
      <div *ngIf="activeTab == tabs.Module" [ngClass]= "activeTab == tabs.Module ? 'tab-pane fade show active' : 'tab-pane fade'" id="module" role="tabpanel" aria-labelledby="Module">
        <app-module [isCurrentTab] = "activeTab" (close)="closeCreateForm()" (setPageTitle)="setPageTitleTriggered($event)" [showForm] = showForm
                    [searchTriggered] = "searchTriggered" [searchTerm]="searchTerm">
        </app-module>
      </div>
      <div *ngIf="activeTab == tabs.SubCategory" [ngClass]= "activeTab == tabs.SubCategory ? 'tab-pane fade show active' : 'tab-pane fade'" id="subCategory" role="tabpanel" aria-labelledby="SubCategory">
        <app-sub-category [isCurrentTab] = "activeTab" (close)="closeCreateForm()" (setPageTitle)="setPageTitleTriggered($event)" [showForm] = showForm
                          [searchTriggered] = "searchTriggered" [searchTerm]="searchTerm">
        </app-sub-category>
      </div>
      <div *ngIf="activeTab == tabs.Metrics" [ngClass]= "activeTab == tabs.Metrics ? 'tab-pane fade show active' : 'tab-pane fade'" id="metric" role="tabpanel" aria-labelledby="Metric">
        <app-metrics [isCurrentTab] = "activeTab" (close)="closeCreateForm()" (setPageTitle)="setPageTitleTriggered($event)" [showForm] = showForm
                     [searchTriggered] = "searchTriggered" [searchTerm]="searchTerm">
        </app-metrics>
      </div>
    </div>
  </section>
